import { forwardRef } from 'react'
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox'
import FormControlLabel, {
  type FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material/FormControlLabel'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'

type FormControlLabelProps = Pick<
  MuiFormControlLabelProps,
  'label' | 'className' | 'slotProps' | 'disableTypography' | 'sx'
>

export interface CheckboxProps
  extends Pick<MuiCheckboxProps, 'inputRef' | 'disabled' | 'onChange'>,
    FormControlLabelProps {
  value?: MuiCheckboxProps['checked']
  error?: boolean
  'data-testid'?: string
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      'data-testid': dataTestId = 'checkbox',
      label,
      value,
      sx,
      error,
      className,
      disableTypography,
      slotProps,
      ...props
    },
    ref,
  ) => (
    <FormControlLabel
      label={label}
      className={className}
      slotProps={slotProps}
      disableTypography={disableTypography}
      sx={mergeSx(sx, {
        ...(error ? { color: ({ palette }) => palette.error.main } : {}),
      })}
      control={
        <MuiCheckbox
          {...props}
          ref={ref}
          checked={value}
          color="secondary"
          data-testid={dataTestId}
          sx={(theme) => ({ ...(error ? { color: theme.palette.error.main } : {}) })}
        />
      }
    />
  ),
)

Checkbox.displayName = 'Checkbox'
